export default {"src":"/_next/static/media/section4-img.704c0267.svg","height":453,"width":556,"blurWidth":0,"blurHeight":0};